<template>
	<header class="main-header">
		<div class="main-header__nav" :class="{ 'main-header__nav--open': menuOpen }">
			<div class="main-header__avatar" @click="toggleNav" :data-initials="user.firstName | initials"></div>
			<ion-icon name="chevron-down" class="main-header__nav-arrow" @click="toggleNav"></ion-icon>
			<div class="main-header__nav-items">
				<router-link :to="{ name: 'profile' }" class="main-header__nav-item" @click.native="toggleNav">
					<ion-icon name="settings"></ion-icon>
					<span>Settings</span>
				</router-link>
				<a @click="logout" class="main-header__nav-item">
					<ion-icon name="exit"></ion-icon>
					<span>Logout</span>
				</a>
			</div>
		</div>
	</header>
</template>

<script>
export default {
	name: 'mainHeader',
	data: () => ({
		menuOpen: false,
	}),
	computed: {
		// menuOpen() {
		// 	return this.$store.getters['navigation/menuOpen']
		// },
		user() {
			return this.$store.getters['user/me']
		},
	},
	methods: {
		toggleNav() {
			this.menuOpen = !this.menuOpen
			// this.$store.dispatch('navigation/menuToggle')
		},
		logout() {
			this.$store.dispatch('user/logout').then(() => {
				this.$router.push({ name: 'login' })
			})
		},
	},
	filters: {
		initials(val, count = 2) {
			if (!val) return val
			let words = val.split(' ')
			if (!words.length) return
			let initials = ''
			for (const word of words) {
				initials += word.charAt(0)
			}

			return initials
		}
	}
}
</script>

<style scoped lang="scss">
@use '@material/elevation';

.main-header {
	@include modules.gutter('padding');

	border-bottom: 1px solid modules.color_('border');
	display: flex;
	align-content: center;
	justify-content: flex-end;

	&__avatar {
		align-items: center;
		background-color: modules.color_('primary');
		border-radius: 50%;
		cursor: pointer;
		display: flex;
		height: 30px;
		justify-content: center;
		margin-right: 10px;
		position: relative;
		width: 30px;

		&:after {
			color: white;
			content: attr(data-initials);
			font-size: 10px;
			font-weight: 600;
			letter-spacing: 2px;
		}
	}

	&__nav {
		$nav: &;
		align-items: center;
		display: flex;
		position: relative;

		&-arrow {
			cursor: pointer;
			transition: transform 150ms modules.$ease-out;

			#{$nav}--open & {
				transform: rotate(180deg);
			}
		}

		&-items {
			@include elevation.elevation(10);
			background-color: white;
			bottom: 0;
			opacity: 0;
			pointer-events: none;
			position: absolute;
			right: 0;
			transform: translateY(100%);
			transition: all 150ms modules.$ease-out;
			z-index: 5;

			#{$nav}--open & {
				opacity: 1;
				pointer-events: all;
				transform: translateY(120%);
			}
		}

		&-item {
			align-items: center;
			border-top: 1px solid modules.color_('border');
			color: modules.color_('text');
			display: flex;
			@include modules.fontSize(14px);
			font-weight: 500;
			padding: 0.75rem 1rem;
			text-decoration: none;
			transition: all 150ms modules.$ease-standard;

			&:first-of-type {
				border-top: 0;
			}

			&:hover {
				background-color: modules.color_('primary');
				color: modules.color_('primary', 'text');
			}

			span {
				margin-left: 10px;
			}
		}
	}

	&__notifications {
		&-icon {
			color: modules.color_('text', 'light');
			@include modules.fontSize(24px);
			margin-right: 1.5em;
		}
	}
}
</style>
